/**
* @Author: 858834013@qq.com
* @Name: index
* @Date: 2022-08-24
* @Desc:
*/
<template>
  <div class="itemBody">
    <titleInfo @getHide="getHide" :title="title">
<!--      <el-dropdown @command="handleCommand" trigger="click">-->
<!--        <div class="dayTime cur">-->
<!--          <span>{{ dateTime }}</span>-->
<!--          <img src="../../../assets/home/icon_down.png" alt="">-->
<!--        </div>-->
<!--        <el-dropdown-menu class="dropdownPop" slot="dropdown">-->
<!--          <el-dropdown-item command="今天">今天</el-dropdown-item>-->
<!--          <el-dropdown-item command="近三天">近三天</el-dropdown-item>-->
<!--          <el-dropdown-item command="近七天">近七天</el-dropdown-item>-->
<!--        </el-dropdown-menu>-->
<!--      </el-dropdown>-->
    </titleInfo>
    <div class="itemBodyMain">
      <echarts></echarts>
    </div>
  </div>
</template>

<script>
import titleInfo from "@/components/titleInfo";
import echarts from "@/components/home/item5/echarts";

export default {
  name: "index",
  components: {titleInfo, echarts},
  props: {
    title: {
      type: String,
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      dateTime: '近七天'
    }
  },
  watch: {},
  mounted() {
  },
  methods: {
    getHide() {
      this.$emit('getHide', 0)
    },
    handleCommand(command) {
      console.log(command)
      this.dateTime = command
    }
  }
}
</script>

<style lang="scss" scoped>
.itemBody {
  position: relative;
  width: 100%;
  height: 100%;

  .itemBodyMain {
    width: 100%;
    position: relative;
    height: calc(100% - 44px);
  }
}

.dayTime {
  width: 93px;
  height: 24px;
  background: url("../../../assets/home/dayTimebg.png") no-repeat;
  background-size: 100% 100%;
  margin-right: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  align-content: flex-start;

  span {
    font-size: 14px;
    font-family: PingFang;
    font-weight: 500;
    color: #46BCFF;
    margin-left: 15px;
    margin-right: 9px;
  }

  img {
    width: 12px;
    height: 6px;
    margin-right: 15px;
  }
}
</style>
